<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-modal
            ref="templateModal"
            :id="id"
            size="xl"
            :title="formData.label ? formData.label : 'New Template'"
    >
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.templateModal.hide()">
                CANCEL
            </b-button>
            <pb-btn :busy="submitProcessing" variant="primary"
                    v-on:click.native="onSubmit()">
                SAVE
            </pb-btn>
        </template>
        <b-container class="text-left">
            <b-row>
                <b-col>
                    <b-form>
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col md="6">
                                <label for="name">Name</label>
                                <b-form-input
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder="Name"
                                        v-model.trim="formData.name"
                                        v-validate="'required'"
                                        :state="validateState('name')"
                                ></b-form-input>
                            </b-col>
                            <b-col>
                                <label for="label">Label</label>
                                <b-form-input
                                        id="label"
                                        name="label"
                                        type="text"
                                        placeholder="Label"
                                        v-model.trim="formData.label"
                                        v-validate="'required'"
                                        :state="validateState('label')"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-button class="float-right my-2" @click="addField">
                            <i class="fal fa-plus"></i> Add
                        </b-button>
                        <b-table primary-key="index" responsive striped hover small
                                 :items="formData.templateFields"
                                 :fields="['index', 'type', 'name', 'label', 'meta', 'actions']">
                            <template v-slot:cell(actions)="row">
                                <b-button variant="link" @click="removeField(row.item.index)">
                                    <i class="fal fa-trash-alt"></i>
                                </b-button>
                            </template>
                            <template v-slot:cell(type)="row">
                                <b-form-select v-model="row.item.type" :options="types"></b-form-select>
                            </template>
                            <template v-slot:cell(name)="row">
                                <b-form-input
                                        :id="'fieldName' + row.index"
                                        :name="'fieldName' + row.index"
                                        type="text"
                                        placeholder="Label"
                                        v-model.trim="row.item.name"
                                ></b-form-input>
                            </template>
                            <template v-slot:cell(label)="row">
                                <b-form-input
                                        name="fieldLabel"
                                        type="text"
                                        placeholder="Label"
                                        v-model.trim="row.item.label"
                                ></b-form-input>
                            </template>
                            <template v-slot:cell(meta)="row">
                                <b-form-input
                                        name="fieledMeta"
                                        type="text"
                                        placeholder="Meta"
                                        v-model.trim="row.item.meta"
                                ></b-form-input>
                            </template>
                        </b-table>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>
<script>


    import TemplateApi from "@shared/_api/cms/template";

    function initialData() {
        return {
            submitProcessing: false,
            submitError: null,
            types: [
                {value: null, text: 'Please select an option'},
                {value: 'HTML', text: 'HTML'},
                {value: 'TEXT', text: 'Plain Text'},
                {value: 'IMAGE', text: 'Bild'},
                {value: 'LONG_TEXT', text: 'Long Text'},
                {value: 'BOOL', text: 'Boolean'},
                {value: 'DATE', text: 'Date'},
                {value: 'TREND_SHOP_TILE', text: 'Trend Shop Tile'},
                {value: 'DESIGN_SHOP_TILE', text: 'Design Shop Tile'},
                {value: 'DESIGN_SHOP_TILE_LIST', text: 'Design Shop Tile List'},
                {value: 'CATEGORY_SELECT', text: 'Category'},
                {value: 'DESIGN_SHOP_TILE_SELECT', text: 'Trend Shop Karte'},
                {value: 'IMAGE_GRID', text: 'Image Grid'},
                {value: 'SIMPLE_LIST', text: 'Simple List'},

            ],
            formData: {
                id: null,
                name: null,
                label: null,
                meta: null,
                templateFields: [],
            },
        }
    }

    export default {
        name: 'page-modal',
        props: {
            id: String
        },
        data() {
            return initialData();
        },
        methods: {
            manageEntity(entity) {
                this.$validator.reset().then(() => {
                    Object.assign(this.$data, initialData());
                    if (entity) {
                        Object.assign(this.$data.formData, entity);
                    }
                    for (let i = 0; i < this.$data.formData.templateFields.length; i++) {
                        this.$data.formData.templateFields[i].index = i + 1;
                    }
                });
            },
            addField() {
                this.formData.templateFields.push({
                    index: this.formData.templateFields.length + 1,
                    id: null,
                    type: null,
                    name: null,
                    label: null
                })
            },
            removeField(index) {
                this.formData.templateFields.splice(index - 1, 1);
            },
            onSubmit() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.submitProcessing = true;
                        TemplateApi.add(this.formData).then(() => {
                            this.$nextTick(() => {
                                this.$emit('saved');
                                this.$refs.templateModal.hide();
                            })
                        }).catch(() => {
                            this.submitError = "An error occured.";
                        }).finally(() => {
                            this.submitProcessing = false;
                        });
                    }
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
